import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --hero-image-padding: calc(44rem / var(--default-rem-px-count));
    }

    /* Mobile rows: media / header / description / CTA. */
    .edward-layout {
      grid-template-rows:
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .media {
      grid-column: 1 / 9;
      grid-row: 1;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .subheader {
      font-size: var(--fs-label-small);
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    /* Closes the text stack; the row gap carries part of the 40px. */
    .cta-btn {
      grid-column: 2 / 8;
      grid-row: 4;
      margin-top: calc(var(--text-stack-cta-gap) - var(--block-row-gap));
    }

    .video-wrap {
      position: relative;
      width: 100%;
    }

    .media video,
    .media img,
    .media .video-poster {
      max-height: 100vw;
      max-width: 100vw;
      object-fit: fill;
      display: block;
    }

    .media .video-poster {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
      transition: opacity 200ms ease;
      pointer-events: none;
    }

    .video-wrap.is-ready .video-poster {
      opacity: 0;
    }

    /* The cluster styles itself; only the offset below the media is ours. */
    image-caption {
      margin-top: calc(14rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      :host {
        --hero-image-padding: calc(44rem / var(--default-rem-px-count));
      }

      /* Rows: media / header + description / CTA. The CTA row collapses
         at 1024, where the button moves up beside the text. */
      .edward-layout {
        grid-template-rows:
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .media {
        grid-column: 2 / 14;
        grid-row: 1;
      }

      .media img,
      .media video,
      .media .video-poster {
        min-height: 250px;
        width: 100%;
        max-height: unset;
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 6;
        grid-row: 2;
        align-self: baseline;
        padding-top: var(--hero-image-padding);
      }

      .description {
        grid-column: 7 / 10;
        grid-row: 2;
        align-self: baseline;
        padding-top: var(--hero-image-padding);
      }

      /* Under the description, not out on the header row: two columns
         here are narrower than the button. */
      .cta-btn {
        grid-column: 7 / 12;
        grid-row: 3;
        place-self: start start;
        margin-top: calc(40rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      img,
      video {
        min-height: 400px;
      }

      .media .video-poster {
        min-height: 400px;
      }

      .header:has(> .subheader) {
        align-self: start;
      }

      .description {
        grid-column: 7 / 11;
      }

      /* Wide enough for the button to rejoin the text row. */
      .cta-btn {
        grid-column: 12 / 14;
        grid-row: 2;
        place-self: baseline right;
        padding-top: var(--hero-image-padding);
        margin-top: 0;
      }
    }
  `,
];
